import type { Theme } from '@mui/material';
import { useMediaQuery } from '@mui/material';

export function useIsMobile() {
  return useMediaQuery((theme: Theme) => theme.breakpoints.down('sm'));
}
